import { render, staticRenderFns } from "./CreateAid.vue?vue&type=template&id=75c9d8ac"
import script from "./CreateAid.vue?vue&type=script&lang=js"
export * from "./CreateAid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports